import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "../css/TextToPayInstructionsModal.css";
import { useNavigate } from "react-router-dom";

const SecurityQAsModal = (props) => {
  const navigate = useNavigate()

  const closeModal = () => {
    props.setShowSecurityQAsModal(false);
  };

  return (
    <>
      <Modal
        dialogClassName="my-modal"
        show={props.showModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        scrollable={true}
        onHide={closeModal}
        centered
      >
        <div className={"mainContainer"}>
          <Modal.Header className={'modalHeaderContainer'}>
            <div className={"headerContainer"}>
              <div className={"titleText"}><span>SECURITY Q&As</span></div>
              <div 
              style={{
                marginLeft: 'auto',
                cursor: 'pointer',
                fontSize: '30px',
                fontWeight: 'bold',
                position: 'absolute',
                top: '0px',
                right: '30px',
                color: '#ffffff'
              }}
              onClick={closeModal}
            >
              &times;
            </div>
            </div>
          </Modal.Header>
          <div className={"bodyContainer"}>
            <div style={{display: "flex",
                          flexDirection: "column",
                          color: "#000000",
                          }}>
              <span>
                Our records indicate that you have not completed your personalized security questions. Please click NEXT to fill out these questions.
              </span>
            </div>
            <div className="roundyUp"></div>
          </div>
        </div>
        <Modal.Footer>
          <div className={"modalFooter"}>
            <div className="btn btn-primary-grad btn-sm m-1" onClick={() => {closeModal(); navigate("/security-qas")}}>Next</div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default SecurityQAsModal;
